export default __webpack_public_path__ + "static/media/SearchEmptyState.9009bdd6.svg";